module.exports = __webpack_public_path__ + "img/menu_1.813fe358.png";